import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fredoka\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/(hotels)/hotels/(search)/[...country]/FavouritedModals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/MobileNav.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ToastLoader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/auth/AuthModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ClinetLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MainClinetDataSetter.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/PageLoadingIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/errors/404.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/utils/handleReferralCode.tsx");
